import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { AppConfigDTO } from "@shared/types";

let cache: Promise<AppConfigDTO> | null = null;

export function useAppConfig(): AppConfigDTO | null {
  const [config, setConfig] = useState<AppConfigDTO | null>(null);
  useEffect(() => {
    if (!cache) cache = api.config();
    let alive = true;
    cache.then((c) => alive && setConfig(c)).catch(() => (cache = null));
    return () => {
      alive = false;
    };
  }, []);
  return config;
}
